<template>
  <div id="app">
    <div class="center navWrapper">
      <app-header :isBetaUser="settings.betaUser" />
    </div>
    <div class="center wrapper">
      <transition name="component-fade" mode="out-in">
        <!-- http://router.vuejs.org/en/essentials/named-views.html -->
        <router-view :categories="categories" :days="days"></router-view>
      </transition>
    </div>

    <!-- FIXME - This still feels like the wrong approach. There should be a single modal that all the rest plug into. Change modal implementation to be the element that actively loads each component as it listens to events or create a modal-manager at the very least -->
    <category-modal :show="showCategoryModal" :categories="categories" />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import CategoryModal from "./components/CategoryModal.vue";

import db from "./db.js";
import eventHub from "./eventHub.js";

export default {
  name: "app",
  components: {
    "app-header": AppHeader,
    "category-modal": CategoryModal,
  },
  props: ["categories", "settings", "days"],
  data() {
    return {
      showCategoryModal: false,
    };
  },
  created() {
    let self = this;
    //TODO - Clean this up/move this somewhere that makes more sense
    //       Register everything in eventHub passing this as context?
    //TODO - Make this more generic to handle multiple modals
    eventHub.$on("set-category-modal-visibility", function(d) {
      self.$set(self, "showCategoryModal", d.isVisible);
    });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-bottom: 4rem;
}

body {
  margin: 0;
}

h1,
h2 {
  font-weight: normal;
}

h1 {
  margin-bottom: 0.5rem;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0 10px;
}

a {
  color: #42b983;
}

.flexRow {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  display: flex;
}

.center {
  margin: 0 auto;
  padding: 0 1rem;
  max-width: 1200px;
}

.center.navWrapper {
  padding: 0;
  max-width: none;
  border-bottom: 1px solid #ddd;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 10;
}

.center.wrapper {
  padding: 2rem;
}

.dataCell {
  display: inline-block;
  padding: 1rem;
  width: 1.5rem;
  height: 1rem;
}

.material-icons.action-icon:hover {
  cursor: pointer;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for <2.1.8 */ {
  opacity: 0;
}

@media (max-width: 600px) {
  .center.wrapper {
    padding: 2rem 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?ee8add64